import { useTranslation } from "react-i18next";

import "./Privacy.css";

const Privacy = () => {
	const { t } = useTranslation();
	const items = t("privacy.paragraphs", { returnObjects: true });

	return (
		<div className="privacy-bg">
			<h1 className="privacy-title">{t("privacy.title")}</h1>

			<div className="privacy-content">
				{items.map((item, index) => {
					if (item["style"] === "br") {
						return <br key={index} />;
					} else if (item["style"] === "bold") {
						return (
							<div key={index} className={`privacy-text-` + item["style"]}>
								<h5 className="privacy-text">{item["text"]}</h5>
							</div>
						);
					} else {
						return <h5 className="privacy-text">{item["text"]}</h5>;
					}
				})}
			</div>
		</div>
	);
};

export default Privacy;
